import React, { useMemo } from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

import MainApp from '../MainApp';
import HelpCenter from '../containers/HelpCenter';
import HelpCenterCategory from '../containers/HelpCenterCategory';
import HelpCenterTopic from '../containers/HelpCenterTopic';
import FAQ from '../containers/FAQ';
import FAQCategory from '../containers/FAQCategory';
import FAQTopic from '../containers/FAQTopic';
import ReleaseNotes from '../containers/ReleaseNotes';
import Search from '../containers/Search';
import ReleaseNote from '../containers/ReleaseNote';
import CustomerEffortScore from '../containers/CustomerEffortScore';

import { routes } from './index';
import useMobileDetect from '../hooks/useMobileDetect';

const Routes = () => {
  const isMobile = useMobileDetect();

  const router = useMemo(
    () =>
      createBrowserRouter([
        {
          element: <MainApp />,
          errorElement: <Navigate to={routes.$root} replace />,
          children: [
            {
              path: routes.$root,
              element: <HelpCenter />,
            },
            {
              path: routes.articles,
              element: <HelpCenter />,
            },
            {
              path: routes.articlesCategory,
              element: <HelpCenterCategory />,
            },
            {
              path: routes.articlesTopic,
              element: <HelpCenterTopic />,
            },
            {
              path: routes.faq,
              element: <FAQ />,
            },
            {
              path: routes.faqCategory,
              element: <FAQCategory />,
            },
            {
              path: routes.faqTopic,
              element: <FAQTopic />,
            },
            {
              path: routes.releaseNotes,
              element: <ReleaseNotes />,
            },
            {
              path: routes.releaseNote,
              element: <ReleaseNote />,
            },
            {
              path: routes.search,
              element: <Search />,
            },
            {
              path: routes.customerEffort,
              element: <CustomerEffortScore />,
            },
          ],
        },
      ]),
    [isMobile],
  );

  return (
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
      }}
    />
  );
};

export default Routes;
